import { combineReducers } from 'redux'
import { sandboxReducer } from './sandbox'

const rootReducer = combineReducers({
  sandboxReducer,
})

export default rootReducer
export type RootState = ReturnType<typeof rootReducer>
